module.exports = __webpack_public_path__ + "img/contact.0c69d882.jpg";